import { makeStyles } from '@material-ui/core';

export const getProposalEditorToolbarTemplatesSectionNameDialogStyles =
  makeStyles(() => ({
    textField: {
      width: '100%',
    },
  }));
